export default "__VITE_ASSET__BKBtClUf__"